export const APPOINTMENT_TYPES = {
  lpu: '',
  club: 'club',
  home: 'na_dom',
  online: 'online',
  telemed: 'telemed',
}
